import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BaseLearningSectionComponent } from '../../../../shared/learning-section/base-learning-section/base-learning-section.component';
import { LearningSectionFlowControlHelperService } from '../../../../_helpers/learning-section-flow-control-helper/learning-section-flow-control-helper.service';
import { ThemeService } from '../../../../_helpers/theming-engine/theme.service';
import { TutorReportsHelperService } from '../../../../_helpers/tutor-reports-helper/tutor-reports-helper.service';
import { StudentGroupSession } from '../../../../_models';

@Component({
    selector: 'app-classic-session-section',
    templateUrl: './classic-session-section.component.html',
    styleUrls: ['./classic-session-section.component.css'],
    standalone: false
})
export class ClassicSessionSectionComponent extends BaseLearningSectionComponent implements OnInit {
  @Input() timelineSection: StudentGroupSession = new StudentGroupSession();

  public initialLearningBandText: string = "";
  public initialKeyStageText: string = "";

  public targetLearningBandText: string = "";
  public targetKeyStageText: string = "";

  constructor(
    protected readonly flowHelperService: LearningSectionFlowControlHelperService,
    public dialog: MatDialog,
    public themeService: ThemeService,
    private tutorReportsHelperService: TutorReportsHelperService
  ) {
    super(flowHelperService, dialog);
    this.sectionTitle = 'Session (Classic)';
  }

  ngOnInit() {
    
  }

}
